import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useCustomization() {
  const { data } = useFetchHelpCenter();
  const customization = data?.customization;
  return customization;
}
